import { render, staticRenderFns } from "./advertising-series-pie.vue?vue&type=template&id=0c59b74c&scoped=true"
import script from "./advertising-series-pie.vue?vue&type=script&lang=js"
export * from "./advertising-series-pie.vue?vue&type=script&lang=js"
import style0 from "./advertising-series-pie.vue?vue&type=style&index=0&id=0c59b74c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c59b74c",
  null
  
)

export default component.exports